import React from 'react';

interface TextAmountSliderProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  descriptions: Record<number, string>;
  min?: number;
  max?: number;
  minLabel?: string;
  maxLabel?: string;
  /** Tighter paddings for sliders laid out side by side. */
  compact?: boolean;
  testId?: string;
}

const TextAmountSlider: React.FC<TextAmountSliderProps> = ({
  label,
  value,
  onChange,
  descriptions,
  min = 0,
  max = 5,
  minLabel = 'None',
  maxLabel = 'Full',
  compact = false,
  testId,
}) => {
  const getIntensityColor = (level: number) => {
    const colors = [
      'bg-white dark:bg-gray-800',
      'bg-green-50 dark:bg-green-900',
      'bg-green-100 dark:bg-green-800',
      'bg-green-200 dark:bg-green-700',
      'bg-green-300 dark:bg-green-600',
      'bg-green-400 dark:bg-green-500',
    ];
    const fraction = max === min ? 0 : (level - min) / (max - min);
    const index = Math.round(fraction * (colors.length - 1));
    return colors[Math.min(Math.max(index, 0), colors.length - 1)];
  };

  return (
    <div
      data-testid={testId}
      className={`${compact ? 'p-3' : 'p-4'} border rounded-lg ${getIntensityColor(value)}`}
    >
      <label className={`block text-sm font-medium ${compact ? 'mb-1' : 'mb-2'}`}>{label}</label>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        className={`w-full ${compact ? 'h-2' : 'h-3'} bg-gray-200 rounded-lg appearance-none cursor-pointer accent-green-500`}
      />
      <div className={`flex justify-between text-xs text-gray-600 ${compact ? 'mt-1' : 'mt-2'}`}>
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
      <div className={`text-sm font-medium text-gray-700 text-center ${compact ? 'mt-1' : 'mt-2'}`}>
        {descriptions[value]}
      </div>
    </div>
  );
};

export default TextAmountSlider;
